import { isEmpty } from "@/helpers/utility/Text.js";
import type { Migration } from "./Migration.js";
import type { ItemStoreState } from "@editor/items/ItemStore";
import type { StoreItem } from "@editor/items/StoreItem.js";

const migration: Migration = {
  applyToVersions: "<2.8.0",
  type: "before",
  name: "migrate the elementMomentums to curves",
  migrate: (
    data: {
      elementMomentums?: ItemStoreState<MigrationMomentumItem>;
    },
    options: {
      oldData?: {
        elementMomentums?: {
          items: {
            [id: number]: {
              id: number;
              percent: number;
              points: number;
              description?: string;
            };
          };
        };
      };
    }
  ) => {
    if (!data.elementMomentums) return data;

    if (!options.oldData?.elementMomentums) return data;

    const oldMomentums = options.oldData.elementMomentums.items;

    for (const momentum of Object.values(data.elementMomentums.items)) {
      const oldMomentum = oldMomentums[momentum.id];
      if (!oldMomentum) continue;

      if (!("percent" in oldMomentum)) continue;

      const startY = oldMomentum.points;
      const endY = oldMomentum.points + oldMomentum.percent;

      // If the momentum is 0, we can just remove it
      if (startY == 0 && endY == 0 && isEmpty(oldMomentum.description ?? "")) {
        delete data.elementMomentums.items[momentum.id];
        data.elementMomentums.order = data.elementMomentums.order.filter(
          (id) => id != momentum.id
        );
        continue;
      }

      data.elementMomentums.items[momentum.id].constantCurvePoints = [
        {
          x: 0,
          y: oldMomentum.points
        },
        {
          x: 100,
          y: oldMomentum.points + oldMomentum.percent
        }
      ];
    }

    return data;
  }
};

interface MigrationMomentumItem extends StoreItem {
  type: "momentum";
  constantCurvePoints: {
    x: number;
    y: number;
  }[];
  constantCurveType: "linear" | "formula";
}

export default migration;
